<template>
  <div class="mb-1">
    <div class="radio-button flex items-center cursor-pointer mb-1">
      <div class="flex items-center h-5">
        <input
          :id="id + '-false'"
          v-model="selectedOption"
          type="radio"
          :value="false"
          :name="name"
          class="focus:ring-alo-800 h-4 w-4 text-alo-200 border-gray-300"
          :class="{ 'with-errors': error }"
        />
      </div>
      <div class="ml-3 text-sm">
        <label :for="id + '-false'" class="label-radio font-medium text-gray-700 select-none cursor-pointer">
          {{ $t('place_order.is_not_portability') }}
        </label>
      </div>
    </div>
    <div class="radio-button flex items-center cursor-pointer">
      <div class="flex items-center h-5">
        <input
          :id="id + '-true'"
          v-model="selectedOption"
          type="radio"
          :value="true"
          :name="name"
          class="focus:ring-alo-800 h-4 w-4 text-alo-200 border-gray-300"
          :class="{ 'with-errors': error }"
        />
      </div>
      <div class="ml-3 text-sm">
        <label :for="id + '-true'" class="label-radio font-medium text-gray-700 select-none cursor-pointer">
          {{ $t('place_order.is_portability') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: null,
    },
    name: {
      type: String,
      default: 'is_portability',
    },
    id: {
      type: String,
      default: () => 'checkbox-' + Math.floor(Math.random() * 100000),
    },
    error: {
      type: Object,
      default: null,
    },
  },
  computed: {
    selectedOption: {
      get() {
        const storedData = JSON.parse(window.localStorage.getItem('place-order-form'))
        return storedData ? storedData.isPortability : this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 450px) {
  .radio-button {
    padding: 6px 0;
  }
  .label-radio {
    font-size: 1rem;
  }
}
</style>
